export const AUTH_METHODS = {
  PASSWORD: 'password',
  EMAIL: 'email',
  SMS: 'sms',
  GOOGLE: 'google',
} as const

export type AuthMethod = (typeof AUTH_METHODS)[keyof typeof AUTH_METHODS]

export const BUTTON_LABELS = {
  [AUTH_METHODS.PASSWORD]: 'Password',
  [AUTH_METHODS.EMAIL]: 'Email Code',
  [AUTH_METHODS.SMS]: 'Continue with Phone',
  [AUTH_METHODS.GOOGLE]: 'Continue with Google',
} as const

export const BUTTON_SUBTITLES = {
  [AUTH_METHODS.PASSWORD]: 'Sign in with your password/passkey',
  [AUTH_METHODS.EMAIL]: 'Get a verification code',
  [AUTH_METHODS.SMS]: 'Verify with SMS',
  [AUTH_METHODS.GOOGLE]: null,
} as const
